import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SignupVerif from './SignupVerif';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message,
  } = state.auth;
  return {
    isLoading,
    data,
    error,
    message,
  };
}

const Styled = withStyles(styles)(SignupVerif);

export default connect(
  mapStateToProps,
)(Styled);
